export const navItems = [
  { path: '/', label: 'Home', section: '§1' },
  { path: '/work', label: 'Work', section: '§2' },
  { path: '/about', label: 'About', section: '§3' },
  { path: '/contact', label: 'Contact', section: '§4' },
] as const;
